(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["promo-club"] && !Shopify.designMode) return;
  try {
    
function enablePromoCopy() {
  document.querySelectorAll('[data-promo-copy]').forEach(button => { button.hidden = false; });
}
enablePromoCopy();
document.addEventListener('shopify:section:load', enablePromoCopy);
document.addEventListener('click', async event => {
  const button = event.target.closest('[data-promo-copy]');
  if (!button) return;
  const card = button.closest('.md-promos__offer');
  const code = card.querySelector('.md-promos__code');
  const status = card.querySelector('.md-promos__copy-status');
  try {
    await navigator.clipboard.writeText(code.textContent.trim());
    status.textContent = button.dataset.copied;
  } catch {
    const range = document.createRange();
    range.selectNodeContents(code);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    status.textContent = button.dataset.fallback;
  }
});

  } catch(e) { console.error(e); }
})();
})();
